/* Shared convenience behavior for the three new simulators. Never changes their models. */
(function () {
  'use strict';
  function currentInput(root) {
    return root.querySelector('#mt-q, #dt-q, #hi-location');
  }
  function copyFallback(value) {
    const area = document.createElement('textarea');
    area.value = value;
    area.setAttribute('readonly', '');
    area.style.cssText = 'position:fixed;left:-9999px;top:0;opacity:0';
    document.body.appendChild(area);
    area.select();
    const ok = document.execCommand && document.execCommand('copy');
    area.remove();
    return !!ok;
  }
  function setup(root) {
    if (root.dataset.cbrnUnifiedBound === '1') return;
    root.dataset.cbrnUnifiedBound = '1';
    const copy = root.querySelector('[data-cbrn-new-copy]');
    if (copy) copy.addEventListener('click', async function () {
      const url = new URL(window.location.href);
      const previewTheme = url.searchParams.get('preview_theme_id');
      url.search = '';
      if (previewTheme && /^\d+$/.test(previewTheme)) url.searchParams.set('preview_theme_id', previewTheme);
      url.hash = '';
      const input = currentInput(root);
      if (input && input.value.trim()) url.searchParams.set('sim_loc', input.value.trim().slice(0, 160));
      if (root.id === 'cbm-hi') {
        const incident = root.querySelector('[data-incident][aria-pressed="true"]');
        if (incident) url.searchParams.set('sim_incident', incident.dataset.incident);
        for (const name of ['release', 'wind']) {
          const control = root.querySelector('#hi-' + name);
          if (control) url.searchParams.set('sim_' + name, control.value);
        }
      } else {
        const unit = root.querySelector('[data-unit][aria-pressed="true"]');
        if (unit) url.searchParams.set('sim_unit', unit.dataset.unit);
      }
      let ok = false;
      try {
        if (navigator.clipboard && navigator.clipboard.writeText) {
          await navigator.clipboard.writeText(url.toString());
          ok = true;
        } else ok = copyFallback(url.toString());
      } catch (_) {
        try { ok = copyFallback(url.toString()); } catch (__) { ok = false; }
      }
      if (ok) {
        copy.classList.add('is-copied');
        copy.setAttribute('aria-label', copy.textContent.trim() + ' ✓');
        window.setTimeout(function () {
          copy.classList.remove('is-copied');
          copy.removeAttribute('aria-label');
        }, 1800);
      } else {
        window.prompt(copy.textContent.trim(), url.toString());
      }
    });
    const params = new URLSearchParams(window.location.search);
    const place = params.get('sim_loc');
    if (!place || place.length > 160) return;
    const input = currentInput(root);
    const form = root.querySelector('#mt-form, #dt-form, #hi-search');
    if (!input || !form) return;
    input.value = place;
    const unit = params.get('sim_unit');
    if (unit === 'mi' || unit === 'km') {
      const button = root.querySelector('[data-unit="' + unit + '"]');
      if (button) button.click();
    }
    if (root.id === 'cbm-hi') {
      const incident = params.get('sim_incident');
      if (['accident', 'drone', 'missile'].includes(incident)) {
        const button = root.querySelector('[data-incident="' + incident + '"]');
        if (button) button.click();
      }
      for (const name of ['release', 'wind']) {
        const select = root.querySelector('#hi-' + name);
        const val = params.get('sim_' + name);
        if (select && val && Array.from(select.options).some(o => o.value === val)) {
          select.value = val;
          select.dispatchEvent(new Event('change', {bubbles:true}));
        }
      }
    }
    const submitLocation = function () {
      try {
        if (form.requestSubmit) form.requestSubmit();
        else form.dispatchEvent(new Event('submit', {bubbles:true,cancelable:true}));
      } catch (_) {}
    };
    if (document.readyState === 'complete') window.setTimeout(submitLocation, 700);
    else window.addEventListener('load', function () {
      window.setTimeout(submitLocation, 700);
    }, {once:true});
  }
  function boot() {
    document.querySelectorAll('.cbrn-new-sim').forEach(setup);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
